import { Box, Flex, Grid, Text } from '@chakra-ui/react'
import React from 'react'

const Discription = () => {
  return (
    <Box w='80%' m='auto' display='-ms-grid'  mb='30px' >
    <Flex   mb='15px'>
    <Grid >
    <Text>The (Pharm)Easy Way To Book Lab Tests Online </Text>
    <Text fontSize='13px'>Book Diagnostics Lab Test Online. Get doorstep sample collection</Text>
    </Grid>
    </Flex>

    <Flex  mb='15px'>
    <Grid>
    <Text>Lab Test Booking Made Simple </Text>
    <Text fontSize='13px'>One of the most popular services PharmEasy 
    offers is diagnostic testing. People need to book pathological tests
     for many reasons. But before booking, they wonder if the diagnostic
      centre can be trusted to produce accurate results and how long they
     might have to wait in a queue to get tested.</Text>
     <Text mt='10px' fontSize='13px'>To bypass these hassles, PharmEasy has set up an 
        extensive network of reputed pathological laboratories
         in India. One such lab is Thyrocare. With Thyrocare on
          board, we can give you access to a wide network of diagnostic
           laboratories.We also offer a home collection of samples as well. 
           Bid adieu to anxious days of wondering 
        where to book diagnostic tests and embrace the PharmEasy way.</Text>
    </Grid>
    </Flex>

    <Flex  mb='15px'>
    <Grid>
    <Text>Lab tests at your doorstep
         </Text>
    <Text fontSize='13px'>To ease your anxieties, PharmEasy offers the facility of 
    doorstep collection. The technician will come to your house to collect samples.
     And all safety precautions are maintained. A fresh collection kit and/or needle
      will be used so that there is no contamination of samples of the spread of diseases.
       We use special ice boxes that meet NABL guidelines to transport your samples. 
       The reports will be sent to you online. 
    That means you won’t have to travel to the diagnostic lab to collect your reports.</Text>
    </Grid>
    </Flex>

    <Flex  mb='15px'>
    <Grid>
    <Text>How can you book diagnostic tests online?</Text>
    <Text fontSize='13px'>
        <li>Visit <a href='https://pharmeasy.in/diagnostics'>https://pharmeasy.in/diagnostics</a> or click on Lab Tests on the PharmEasy website or app.
        </li>
        <li>Upload your prescription or choose the lab test from the search box.
        </li>
        <li> Alternatively, you can call our customer service team on 7022000900 and they will make the booking for you
        </li>
    </Text>
    </Grid>
    </Flex>

    <Flex  mb='15px'>
    <Grid>
    <Text>Looking to book a pathology test? Here’s how PharmEasy can help!</Text>
    <Text fontSize='13px'>Online diagnostic tests work as smoothly as 
    clockwork. Once you’ve booked the pathology test you need with the
     diagnostic centre you prefer, you will get a confirmation on your
      registered e-mail id and SMS. The backend support team might also
       call you to confirm the booking.Post this our expert technician will
        arrive at your place at the selected slot and collect your sample for
         processing at our state of the art labs. Reports will be shared with you over SMS and 
    will also be available in your account on app/web.</Text>
    </Grid>
    </Flex>

    <Flex  mb='15px'>
    <Grid>
    <Text>Why choose PharmEasy to book lab tests? </Text>
    <Text mb='10px' fontSize="13px">We can give you reasons galore for choosing PharmEasy</Text>
    <Text fontSize='13px'>
        <li>2 Lac+ happy customers</li>
        <li>Safe home sample collection</li>
        <li>Up to 70% OFF</li>
        <li>Certified & 100% Automated labs</li>
        <li>Certified & 100% Automated labs</li>
        <li>Timely and accurate reports</li>
        <li>500+ tests and health packs to choose from</li>
        
    </Text>
    <Text mt='10px' fontSize="13px">Now that you know why PharmEasy can be your
     trusted diagnostic test booking partner, 
    don’t wait, download the PharmEasy app today and book a health check right away.</Text>
    </Grid>
    </Flex>
</Box>
  )
}

export default Discription